var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmileHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101px",
    height: "101px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "smile-heart"), /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool."), /*#__PURE__*/React.createElement("g", {
    id: "people",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smile-heart",
    fill: "#2563eb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,22 C5.581722,22 2,18.418278 2,14 C2,9.581722 5.581722,6 10,6 C14.418278,6 18,9.581722 18,14 C18,18.418278 14.418278,22 10,22 Z M10,20 C13.3137085,20 16,17.3137085 16,14 C16,10.6862915 13.3137085,8 10,8 C6.6862915,8 4,10.6862915 4,14 C4,17.3137085 6.6862915,20 10,20 Z M13,15 C13,16.6568542 11.6568542,18 10,18 C8.34314575,18 7,16.6568542 7,15 L13,15 Z M8,13 C8.55228475,13 9,12.5522847 9,12 C9,11.4477153 8.55228475,11 8,11 C7.44771525,11 7,11.4477153 7,12 C7,12.5522847 7.44771525,13 8,13 Z M12,13 C11.4477153,13 11,12.5522847 11,12 C11,11.4477153 11.4477153,11 12,11 C12.5522847,11 13,11.4477153 13,12 C13,12.5522847 12.5522847,13 12,13 Z M18.625,8 C17.7980697,7.8203108 15.25,6.41000009 15.25,3.875 C15.25,2.83946609 16.0894661,2 17.125,2 C17.7383496,2 18.2829142,2.29450366 18.625,2.7498172 C18.9670858,2.29450366 19.5116504,2 20.125,2 C21.1605339,2 22,2.83946609 22,3.875 C22,6.41000009 19.4519303,7.8203108 18.625,8 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileHeart);
export default __webpack_public_path__ + "static/media/smile-heart.1de5e65025953f4d31914e3828017175.svg";
export { ForwardRef as ReactComponent };